var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-200"},[_c('div',{staticClass:"flex justify-center items-center min-h-screen"},[_c('nuxt')],1),_vm._v(" "),_c('LayoutFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }